module.exports = __webpack_public_path__ + "static/media/Chifeng, China.230d3171.png";